import { render, staticRenderFns } from "./lightSwiper.vue?vue&type=template&id=278d262c&scoped=true&"
import script from "./lightSwiper.vue?vue&type=script&lang=js&"
export * from "./lightSwiper.vue?vue&type=script&lang=js&"
import style0 from "./lightSwiper.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lightSwiper.vue?vue&type=style&index=1&id=278d262c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278d262c",
  null
  
)

export default component.exports